import React from 'react'
import Logo from "../../Reutilizables/Logo"
import Menu from "../../Reutilizables/Menu"
import Footer from "../../Reutilizables/Footer"
import "../../../styles/suscribirse.css"

function Suscribirse() {
  return (
    <>
      <div className='container-logo-menu'>
        <Logo />
        <Menu />
      </div>

      <div className='body-suscribirse'>
        <div className="card-suscripcion card1-suscribirse">
          <div className='logo-tributos-suscribirse'>
          </div>
          <h3 className='tittle-card-suscripcion'>Tributos y finanzas</h3>
          <h5 className='subtittle-card-suscripcion'> Suscripción Mensual Estándar</h5>
          <ul className='beneficios-suscripcion'>
            <li>Acceso completo a todas las funciones premium.</li>
            <li>Actualizaciones exclusivas y contenido premium.</li>
            <li>Atención al cliente prioritaria.</li>
            <li>Flexibilidad para cancelar en cualquier momento.</li>
          </ul>
          <div>
            
          </div>
        </div>

        <div className="card-suscripcion card2-suscribirse">
          <div className='logo-tributos-suscribirse'>
          </div>
          <h3 className='tittle-card-suscripcion'>Tributos y finanzas</h3>
          <h5 className='subtittle-card-suscripcion'>Suscripción Semestral Plus</h5>
          <ul className='beneficios-suscripcion'>
            <li>Todo lo incluido en el plan mensual.</li>
            <li>Ahorro significativo en comparación con la suscripción mensual.</li>
            <li>Renovación automática para una experiencia continua sin interrupciones.</li>
            <li>Atención al cliente prioritaria y acceso exclusivo.</li>
          </ul>
        </div>

        <div className="card-suscripcion card3-suscribirse">
          <div className='logo-tributos-suscribirse'>
          </div>
          <h3 className='tittle-card-suscripcion'>Tributos y finanzas</h3>
          <h5 className='subtittle-card-suscripcion'>Suscripción Anual Elite</h5>
          <ul className='beneficios-suscripcion'>
            <li>Incluye todo en los planes mensual y semestral.</li>
            <li>Renovación automática anual para una experiencia sin complicaciones.</li>
            <li>Descuento adicional en comparación con otras suscripciones.</li>
            <li>Acceso exclusivo a eventos especiales y regalos sorpresa.</li>
          </ul>
        </div>

        <a className='body-suscribirse-botton body-suscribirse-botton1' 
           href="https://www.mercadopago.com.co/subscriptions/checkout?preapproval_plan_id=2c9380848a3be091018a4207899e0406" target='blank'>
          Obtener $1.600
        </a>

        <a className='body-suscribirse-botton body-suscribirse-botton2' 
           href="https://www.mercadopago.com.co/subscriptions/checkout?preapproval_plan_id=2c9380848bbab262018bd516eb1a130a" target='blank'>
          Obtener $8.640
        </a>
          
        <a className='body-suscribirse-botton body-suscribirse-botton3'
            href="https://www.mercadopago.com.co/subscriptions/checkout?preapproval_plan_id=2c9380848bbab262018bd518eac0130b" target='blank'>
          Obtener $15.360
        </a>
      </div>

      <div className="footer-suscripciones">
        <Footer />
      </div>
    </>
  )
}

export default Suscribirse
